import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Loader from "@/components/Loader";

export const roleHome = (role) => {
  if (["admin", "super_admin", "franchise_owner", "branch_manager"].includes(role)) return "/admin";
  if (role === "trainer") return "/trainer";
  return "/member";
};

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}
